/** Desktop always copies, even when its browser exposes the OS share sheet.
 * Keep this small browser adapter aligned in the public and Expo web bundles.
 */
export function usesMobileShareSheet(): boolean {
  if (typeof navigator === 'undefined') return false;
  const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (/Macintosh|MacIntel/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
  return mobile && typeof navigator.share === 'function';
}

export async function shareBrowserLink(url: string): Promise<'shared' | 'copied' | 'cancelled'> {
  if (usesMobileShareSheet()) {
    try {
      // Invoke before any await/timer so mobile browsers retain click activation.
      await navigator.share({ url });
      return 'shared';
    } catch (error) {
      if ((error as Error)?.name === 'AbortError') return 'cancelled';
      throw error;
    }
  }
  // Clipboard errors are handled inline by the caller, with a selectable URL.
  await navigator.clipboard.writeText(url);
  return 'copied';
}
